export function requestIdleCallbackPolyfill(
  callback: IdleRequestCallback,
  options?: IdleRequestOptions,
): number {
  const start = Date.now();
  const timeout = options && typeof options.timeout === 'number' ? options.timeout : 50;
  let didTimeout = false;

  const runCallback = () => {
    didTimeout =
      !!options && typeof options.timeout === 'number' && Date.now() - start >= options.timeout;
    const deadline = {
      didTimeout,
      timeRemaining: () => Math.max(0, 50 - (Date.now() - start)),
    };
    callback(deadline);
  };

  const timerId = setTimeout(runCallback, timeout) as unknown as number;
  return timerId;
}

export function cancelIdleCallbackPolyfill(id: number): void {
  clearTimeout(id);
}
